module.exports = __webpack_public_path__ + "static/media/section_ucas.e5eedf01.jpg";